import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const ProductDetailOpticsFeatures = ({ labels: { frame , antiReflex , antiScratch  } , className  })=>/*#__PURE__*/ React.createElement("ul", {
        className: classnames('product-detail-optics-features', className)
    }, !!frame && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), frame), !!antiReflex && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiReflex), antiScratch && /*#__PURE__*/ React.createElement("li", {
        className: "product-detail-optics-features__feature"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark-circle",
        viewBox: "-1 -1 26 26"
    }), antiScratch))
;

export { ProductDetailOpticsFeatures };
//# sourceMappingURL=ProductDetailOpticsFeatures.js.map
